import { Gem, Shirt, Truck, MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ITEMS = [
  { icon: Gem, title: "Premium Quality", text: "Finest fabrics & exceptional craftsmanship" },
  { icon: Shirt, title: "Exclusive Designs", text: "Unique styles, crafted with elegance" },
  { icon: Truck, title: "Fast Delivery", text: "Quick & reliable shipping across the UK" },
  { icon: MapPin, title: "London Store", text: "Visit our store in the heart of East London" },
];

export const TrustIcons = () => (
  <section className="bg-surface py-14 lg:py-16" data-testid="trust-section">
    <div className="max-w-3xl mx-auto px-6 sm:px-8 divide-y divide-black/[0.07]">
      {ITEMS.map((item, i) => (
        <Reveal key={item.title} delay={i * 0.06}>
          <div className="group flex items-center gap-5 sm:gap-7 py-5">
            <item.icon
              className="w-6 h-6 sm:w-7 sm:h-7 text-pink shrink-0 transition-transform duration-300 group-hover:scale-110"
              strokeWidth={1.6}
            />
            <h4 className="font-sans text-sm sm:text-base font-semibold uppercase tracking-[0.16em] text-charcoal w-40 sm:w-52 shrink-0">
              {item.title}
            </h4>
            <p className="font-sans text-xs sm:text-sm text-gray-500 leading-relaxed">
              {item.text}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
